module.exports = __webpack_public_path__ + "static/media/Nguyen_Trung_Thanh.bc74ec4c.png";